module.exports = __webpack_public_path__ + "static/media/1021412.4cec3352.jpg";